import AppInitializer from './AppInitializer';
import './AppInitializer.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';


// Actions
import { createNewUserOrSignIn } from '../../../redux/auth/actions';
import {
  getLoyaltyCardFromCookies,
  getCardBalance
} from '../../../redux/loyalty/actions';
import { getCampaigns } from '../../../redux/campaigns/actions';
import { postAllEngagementAnswers } from '../../../redux/answers/actions';
import { setLoading } from '../../../redux/loading/actions';
import {
  registerSuperProps,
  startSession,
  // mixpanelOnBeforeCloseHandler,
  // mixpanelPageVisibilitySessionDurationTimer
} from '../../../redux/mixpanel/actions';


// Redux
const mapStateToProps = (state) => {
  const authToken = state.auth.token;
  const loyaltyId = state.loyalty.cardNumber;

  return {
    token: state.auth.token,
    userId: state.auth.userId,
    loyaltyCardNumber: state.loyalty.cardNumber,
    isAuthenticated: (
         authToken !== null
      && authToken !== undefined
      && authToken.length > 0
      && loyaltyId !== null
      && loyaltyId !== undefined
      && loyaltyId.length > 0
    ) ? true : false,
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    // Auth
    createNewUserOrSignIn,
    // Loyalty
    getLoyaltyCardFromCookies,
    getCardBalance,
    // Campaigns
    getCampaigns,
    // Answers
    postAllEngagementAnswers,
    // Loading
    setLoading,
    // Mixpanel
    registerSuperProps,
    startSession,
    // mixpanelOnBeforeCloseHandler,
    // mixpanelPageVisibilitySessionDurationTimer,
  }, dispatch);
}

const ConnectedAppInitializer = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AppInitializer));

export default ConnectedAppInitializer;



// WEBPACK FOOTER //
// ./src/HOC/withAppInitilizationChecks/AppInitializer/index.js